<template>
  <div :id="componentId" class="sp2-module-1" :style="moduleStyle">
    <div class="sp2-main-image-wrap" :style="{ backgroundColor: backgroundColor }" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
      <a
        v-if="currentItem && currentItem.url"
        class="sp2-main-image-link"
        :href="currentItem.url"
        target="_blank"
        @click.prevent="goTo(currentItem.url)"
      >
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-main-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-main-image-placeholder">请配置轮播大图</div>
      </a>
      <div v-else class="sp2-main-image-link">
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-main-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-main-image-placeholder">请配置轮播大图</div>
      </div>
    </div>

    <div class="sp2-thumbnail-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="sp2-thumbnail-item"
        :class="{ active: currentIndex === index, last: index === list.length - 1 }"
        @click="goToIndex(index)"
      >
        <img
          v-if="item.imageUrl"
          class="sp2-thumbnail-image"
          referrerpolicy="no-referrer"
          :src="item.imageUrl"
        />
        <div v-else class="sp2-thumbnail-placeholder">缩略图</div>
        <div v-if="index === list.length - 1 && list.length > 1" class="sp2-thumbnail-dots">
          <span
            v-for="(dot, dotIndex) in list"
            :key="dotIndex"
            :class="['sp2-dot', { active: currentIndex === dotIndex }]"
            @click.stop="goToIndex(dotIndex)"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SpTwoModule1',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_1'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      list: [
        {
          imageUrl: '',
          url: ''
        }
        ,
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        }
      ],
      currentIndex: 0,
      timer: null
    };
  },
  computed: {
    currentItem() {
      return this.list[this.currentIndex] || null;
    },
    hasMultiple() {
      return this.list.length > 1;
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
  mounted() {
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      if (!this.hasMultiple) return;
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.list.length;
      }, 4000);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goToIndex(index) {
      if (index < 0 || index >= this.list.length) return;
      this.currentIndex = index;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goTo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.sp2-module-1 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-main-image-wrap {
  width: 2000px;
  min-width: 2000px;
  height: 600px;
  overflow: hidden;
}

.sp2-main-image-link {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.sp2-main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  cursor: pointer;
}

.sp2-main-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  color: #909399;
  font-size: 16px;
}

.sp2-thumbnail-list {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0;
  margin-top: -100px;
  padding: 0;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
}

.sp2-thumbnail-item {
  position: relative;
  width: 280px;
  height: 160px;
  flex-shrink: 0;
  overflow: hidden;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-thumbnail-item.last {
  overflow: visible;
}

.sp2-thumbnail-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.sp2-thumbnail-item.active::after {
  opacity: 0;
}

.sp2-thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-thumbnail-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #e0e0e0;
}

.sp2-thumbnail-dots {
  position: absolute;
  top: -28px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 3;
}

.sp2-dot {
  width: 18px;
  height: 4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-dot.active {
  background: #c00000;
}
</style>
